import { Suspense, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { i18n } from '@shared/lib/i18n/config';

export function I18nProvider({ children }: { children: ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense
        fallback={
          <div className="flex h-screen items-center justify-center">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          </div>
        }
      >
        {children}
      </Suspense>
    </I18nextProvider>
  );
}
